import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Track } from '@app/core/models/Track';
import { AppState } from '@app/core/states/app.state';
import { ForceAddToPlaylistRequest } from '@app/library/states/playlists.actions';
import { getEllipsisTitle } from '@app/shared/utils';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

interface DataInput {
  isSingle: boolean;
  track?: Track;
  trackIdList?: number[];
  playlistId: number;
  position: number;
}

@Component({
  selector: 'rk-add-duplicate-modal',
  templateUrl: './add-duplicate-modal.component.html',
  styleUrls: ['./add-duplicate-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddDuplicateModalComponent {
  isLoading$: Observable<boolean>;

  @Select(AppState.onMobile)
  onMobile$: Observable<boolean>;

  constructor(
    public readonly dialogRef: MatDialogRef<AddDuplicateModalComponent>,
    private readonly store: Store,
    @Inject(MAT_DIALOG_DATA) public dataIn: DataInput,
  ) {}

  getEllipsisTitle() {
    return getEllipsisTitle(this.dataIn.track);
  }

  addDuplicatesMode(mode: string) {
    this.dialogRef.close();
    if (mode === 'skip' && this.dataIn.isSingle) {
      return;
    }
    this.store.dispatch(
      new ForceAddToPlaylistRequest(
        this.dataIn.playlistId,
        this.dataIn.isSingle ? [this.dataIn.track.id] : this.dataIn.trackIdList,
        mode,
        this.dataIn.position,
      ),
    );
  }

  onAbort() {
    this.dialogRef.close(false);
  }
}
